import urlBuilder from '@sanity/image-url'
import { ImageUrlBuilder } from '@sanity/image-url/lib/types/builder'
import { SanityImageSource } from '@sanity/image-url/lib/types/types'

import sanityConfig from '~/config/sanity'

// Same config the Sanity client uses, so image URLs can't diverge from the queries.
const urlFor = (source: SanityImageSource): ImageUrlBuilder => {
  return urlBuilder({ projectId: sanityConfig.projectId, dataset: sanityConfig.dataset }).image(source)
}

interface Props {
  alt: string
  asset: SanityImageSource
  maxWidth: any
}

const SanityImage = ({ alt, asset, maxWidth }: Props): React.ReactElement => {
  const imageSizes = [320, 480, 640, 750, 828, 960, 1080, 1200, 1440]
  const srcUrlSet = imageSizes.map((w) => {
    return `${urlFor(asset).width(w).url()}&auto=format ${w}w`
  })

  return (
    <picture className="block mx-auto max-w-full">
      <img
        alt={alt}
        className="block mx-auto max-w-full"
        loading="eager"
        sizes="(max-width: 768px) 322px, (max-width: 1080px) 550px, 650px"
        src={urlFor(asset).url()}
        srcSet={srcUrlSet.join(', ')}
        style={maxWidth > 0 ? { width: '100%', maxWidth: `${maxWidth}px` } : {}}
      />
    </picture>
  )
}

export default SanityImage
